<template>
    <div>
        <menu2 style="z-index: 999" page_name="发票抬头管理" back_type="close" back_icon="md-close"></menu2>
        <div style="height: 40px;"></div>
        <div class="table_div">
            <Input size="small" style="width:300px;margin-bottom:10px" search enter-button v-model="search_name"
                placeholder="筛选抬头.." @on-click="search" @on-enter="search" @on-search="search" @on-change="search" />

            <Table :height="windowHeight - 140" size="small" :columns="columns" :data="data">
                <template #action="{ row }">
                    <Button size="small" @click="update_title(row)">编辑</Button>
                </template>
            </Table>
        </div>
        <div class="page_div">
            <Page :total="total" :page-size="limit" @on-change="page_change" v-model="page" />
        </div>

        <Modal v-model="update_title_show" title="编辑抬头" :mask-closable="false" :footer-hide="true" width="400">
            <div>
                <div>
                    <Input v-model="update_title_jindie_code" placeholder="输入金蝶编号..." style="width: 300px" />

                </div>
                <div class="update_btn">
                    <Button type="primary" @click="click_update">确认更新</Button>
                </div>
            </div>
        </Modal>
    </div>
</template>

<script>
import menu2 from "@/component/menu/menu2.vue";
import { get_view_file_url, http, open_new_page } from "@/utils/http.js";

export default {
    components: {
        menu2,
    },
    data() {


        return {

            windowWidth: document.documentElement.clientWidth, //实时屏幕宽度
            windowHeight: document.documentElement.clientHeight, //实时屏幕高度
            page: 1,
            limit: 20,
            search_name: '',
            columns: [],
            data: [],
            total: 0,
            update_title_jindie_code:'',
            update_title_item: {},
            update_title_show: false
        }
    },
    mounted() {
        this.get_title_list()
    },
    methods: {
        click_update() {
            var that = this;
            var obj = {
                pit_id: this.update_title_item.pit_id,
                jindie_code: this.update_title_jindie_code
            };
            http(
                "post",
                process.env.VUE_APP_HOST + "/finance/invoice/invoice_title_update",
                obj,
                true
            )
                .then((res) => {
                    if (res.code == 0) {
                        that.$Message.success({
                            content: res.msg,
                            duration: 3,
                        });
                        that.get_title_list()

                        that.update_title_show=false
                    } else {
                        that.$Message.error({
                            content: res.msg,
                            duration: 3,
                        });
                    }
                })
                .catch((res) => {
                    console.log(res, "请求出错");
                });

        },
        update_title(row) {
            this.update_title_show = true
            this.update_title_item = row
            this.update_title_jindie_code = row.jindie_code
        },
        search() {
            this.page = 1;
            this.get_title_list();
        },
        page_change(e) {
            this.page = e
            this.get_title_list()
        },
        get_title_list() {
            var that = this;
            var obj = {
                page: this.page,
                limit: this.limit,
                'search_name': this.search_name
            };
            http(
                "post",
                process.env.VUE_APP_HOST + "/finance/invoice/invoice_title_list",
                obj,
                true
            )
                .then((res) => {
                    if (res.code == 0) {

                        that.data = res.data.data_list;
                        that.columns = res.data.columns;
                        that.total = res.data.total

                    } else {
                        that.$Message.error({
                            content: res.msg,
                            duration: 3,
                        });
                    }
                })
                .catch((res) => {
                    console.log(res, "请求出错");
                });
        },

    }
}
</script>

<style scoped>
.update_btn {
    display: flex;
    justify-content: end;
    margin-top: 20px;
    ;
}

.page_div {
    display: flex;
    justify-content: center;
}

.table_div {
    margin: 10px;
    border-radius: 10px;
}

.page_main {
    background-color: #efefef;
    height: 100vh;
    overflow: auto;
}
</style>